import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Voucher } from 'app/models/voucher.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComprobantesService {

  constructor(private http: HttpClient) { }

  getCompras(): Observable<Voucher | any> {
    return this.http.get(environment.apiUrl + `vouchers/type/purchases`);
  }

  /**
   * Obtiene los remitos por tipo (compra o venta)
   * @param type Tipo de remito: 'compra' o 'venta'
   * @param search Término de búsqueda opcional
   * @returns Observable con los remitos
   */
  getRemitos(type: 'compra' | 'venta', search?: string): Observable<any> {
    let params = new HttpParams().set('type', type);
    
    // Solo agregar el parámetro search si se proporciona y el endpoint lo soporta
    // Comentado ya que el endpoint no acepta este parámetro
    // if (search && search.trim().length > 0) {
    //   params = params.set('search', search.trim());
    // }
    
    const url = environment.apiUrl + 'vouchers/remitos';
    console.log(`Llamando endpoint: ${url} con parámetros:`, params.toString());
    
    return this.http.get(url, { params });
  }

  /**
   * Obtiene las compras aplicando filtros
   * @param filtros Objeto con los filtros a aplicar
   * @returns Observable con los datos filtrados
   */
  getComprasConFiltros(filtros: any): Observable<Voucher | any> {
    let params = new HttpParams();
    
    // Añadir los filtros a los parámetros HTTP
    if (filtros.fechaDesde) {
      params = params.append('fechaDesde', filtros.fechaDesde);
    }
    
    if (filtros.fechaHasta) {
      params = params.append('fechaHasta', filtros.fechaHasta);
    }
    
    if (filtros.tipoComprobante) {
      params = params.append('tipoComprobante', filtros.tipoComprobante);
    }
    
    if (filtros.proveedor) {
      params = params.append('proveedor', filtros.proveedor);
    }
    
    if (filtros.enviado !== '') {
      params = params.append('enviado', filtros.enviado ? '1' : '0');
    }
    
    if (filtros.electronico !== '') {
      params = params.append('electronico', filtros.electronico ? '1' : '0');
    }
    
    return this.http.get(environment.apiUrl + 'vouchers/type/purchases', { params });
  }

  getComprobantes(): Observable<Voucher | any> {
    return this.http.get(environment.apiUrl + 'vouchers');
  }

  getComprobanteById(id): Observable<Voucher | any> {
    return this.http.get(environment.apiUrl + `vouchers/${id}`);
  }

  getComprobanteBytypeNumero(type): Observable<any> {
    return this.http.get(environment.apiUrl + `vouchers/next/${type}`);
  }

  getComprobanteByCliente(idcliente): Observable<any> {
    return this.http.get(environment.apiUrl + `vouchers/cliente/${idcliente}`);
  }

  getComprobanteByRecibo(idCliente): Observable<any> {
    return this.http.get(environment.apiUrl + `vouchers/cliente/${idCliente}/facturas-notas-debito-pendientes`);
  }

  guardarComprobante(comprobante: Voucher): Observable<any> {
    return this.http.post(environment.apiUrl + 'vouchers', comprobante)
  }

  /**
   * Actualiza un comprobante existente
   * @param id Identificador único del comprobante
   * @param comprobante Datos del comprobante a actualizar
   * @returns Observable con la respuesta del servidor
   */
  actualizarComprobante(id: number, comprobante: Voucher): Observable<any> {
    if (!id || isNaN(id)) {
      throw new Error('ID de comprobante inválido');
    }
    return this.http.patch(environment.apiUrl + `vouchers/${id}`, comprobante);
  }

  /**
   * Elimina un comprobante específico
   * @param id Identificador único del comprobante a eliminar
   * @returns Observable con la respuesta del servidor
   */
  eliminarComprobante(id: number): Observable<{success: boolean, message: string}> {
    if (!id || isNaN(id)) {
      throw new Error('ID de comprobante inválido');
    }
    return this.http.delete<{success: boolean, message: string}>(environment.apiUrl + `vouchers/${id}`);
  }

}
